import { Form } from 'factorial-form'

import { CAPACITY_UNITS, NEGATIVE_TRANSFERS, UPDATE_FREQUENCY } from 'modules/attendance/lib/enums'

class TimeoffCompensationForm extends Form {
  constructor(values = {}) {
    const defaultValues = {
      compensation_enabled: false,
      frequency: UPDATE_FREQUENCY.daily,
      has_threshold_enabled: false,
      threshold_capacity: null,
      threshold_units: CAPACITY_UNITS.hours,
      compensation_capacity: null,
      compensation_units: CAPACITY_UNITS.hours,
      has_unlimited_compensation: true,
      negative_transfers: NEGATIVE_TRANSFERS.none,
    }

    super(
      { ...defaultValues, ...values },
      {
        compensation_enabled: 'boolean',
        frequency: 'string',
        has_threshold_enabled: 'boolean',
        threshold_capacity: 'number',
        threshold_units: 'string',
        compensation_capacity: 'number',
        compensation_units: 'string',
        has_unlimited_compensation: 'boolean',
        negative_transfers: 'string',
        attendance_employees_setting_id: 'number',
      }
    )
  }

  negativeTransfersEnabled(): boolean {
    return this.get('negative_transfers').value !== NEGATIVE_TRANSFERS.none
  }

  onNegativeTransfersChange(): void {
    const currentValue = this.get('negative_transfers').value
    const newNegativeTransfers =
      currentValue == NEGATIVE_TRANSFERS.unlimited
        ? NEGATIVE_TRANSFERS.none
        : NEGATIVE_TRANSFERS.unlimited
    this.setValues({ negative_transfers: newNegativeTransfers })
  }

  negativeTransfersOptions(): string[] {
    return Object.keys(NEGATIVE_TRANSFERS).filter(
      (negative_transfer) => negative_transfer !== NEGATIVE_TRANSFERS.none
    )
  }

  isCompensationCapacityZero(): boolean {
    return this.get('compensation_capacity').value === '0'
  }

  isCompensationCapacityUnlimited = (): boolean => {
    return this.get('has_unlimited_compensation').value
  }
}

export default TimeoffCompensationForm
